// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._2pWVk{-ms-flex-wrap:wrap;flex-wrap:wrap;-ms-flex-align:start;align-items:flex-start;max-width:750px;margin:0 auto}._2pWVk,._2pWVk>div{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}._2pWVk>div{-ms-flex-direction:column;flex-direction:column;text-align:center;width:250px;margin-bottom:45px}._2pWVk>div h3{line-height:20px;font-weight:500}._2pWVk>div>div{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center}._2pWVk>div>div img{margin-bottom:5px}", ""]);
// Exports
exports.locals = {
	"itemWrapper": "_2pWVk"
};
module.exports = exports;
